import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase"; // Import your Firebase configuration
import { Modal, Button, Form, Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../style/FacilityTable.css";

export default function AdminFacilityTable() {
  let unsubscribe;

  const [facilities, setFacilities] = useState([]);
  const [users, setUsers] = useState([]);
  const [filteredFacilities, setFilteredFacilities] = useState([]);
  const [searchFacilityName, setSearchFacilityName] = useState("");
  const [searchMerchantName, setSearchMerchantName] = useState("");
  const [filterType, setFilterType] = useState("");
  const [sortType, setSortType] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const facilitiesPerPage = 10;
  const [showModal, setShowModal] = useState(false);
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [selectedFacilityDetails, setSelectedFacilityDetails] = useState(null);
  const [selectedFacilityRating, setSelectedFacilityRating] = useState([]);
  const [shownDescription, setShownDescription] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [facilityToDelete, setFacilityToDelete] = useState(null);
  const [facilityNameToDelete, setFacilityNameToDelete] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [facilityToEdit, setFacilityToEdit] = useState(null);
  const [editedFacilityName, setEditedFacilityName] = useState("");
  const [editedFacilityLocation, setEditedFacilityLocation] = useState("");
  const [editedFacilityType, setEditedFacilityType] = useState("");
  const [editedFacilityDescription, setEditedFacilityDescription] =
    useState("");
  const [editedCustomDescription, setEditedCustomDescription] = useState("");
  const [inputError, setInputError] = useState("");
  const [isCustomDescription, setIsCustomDescription] = useState(false);
  const [error, setError] = useState("");
  const facilityTypes = ["Toilet", "Rest", "Other"];

  const indexOfLastFacility = currentPage * facilitiesPerPage;
  const indexOfFirstFacility = indexOfLastFacility - facilitiesPerPage;
  const facilitiesToShow = filteredFacilities.slice(
    indexOfFirstFacility,
    indexOfLastFacility
  );
  const totalPages = Math.ceil(filteredFacilities.length / facilitiesPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    const fetchFacilities = async () => {
      try {
        const docRef = collection(db, "facility");
        const querySnapshot = await getDocs(docRef);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const docRefMerchant = collection(db, "merchants");
        const querySnapshotMerchant = await getDocs(docRefMerchant);
        const dataMerchant = querySnapshotMerchant.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        data.forEach((facility) => {
          const merchantId = facility.merchant_id;
          dataMerchant.forEach((merchant) => {
            if (merchantId == merchant.id) {
              facility.merchant = merchant;
            }
          });
          console.log(
            "Facility: ",
            facility.facilityName,
            "Merchant",
            facility.merchant
          );
        });

        setFacilities(data);
        setFilteredFacilities(data);

        // Set up a real-time listener for changes
        unsubscribe = onSnapshot(docRef, (snapshot) => {
          const updatedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          updatedData.forEach((facility) => {
            const merchantId = facility.merchant_id;
            dataMerchant.forEach((merchant) => {
              if (merchantId == merchant.id) {
                facility.merchant = merchant;
              }
            });
            console.log(
              "Facility: ",
              facility.facilityName,
              "Merchant",
              facility.merchant
            );
          });

          setFacilities(updatedData);
          setFilteredFacilities(updatedData);
        });
      } catch (error) {
        console.error("Error fetching facilities: ", error);
      }
    };

    const fetchUsers = async () => {
      try {
        const docRef = collection(db, "users");
        const querySnapshot = await getDocs(docRef);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log("User data: ", data);
        setUsers(data);

        // Set up a real-time listener for changes
        unsubscribe = onSnapshot(docRef, (snapshot) => {
          const updatedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setUsers(updatedData);
        });
      } catch (error) {
        console.error("Error fetching users: ", error);
      }
    };

    fetchFacilities();
    fetchUsers();

    return () => {
      // Unsubscribe from the listener when component unmounts
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  const handleSearchFacilityName = (event) => {
    const searchFacilityName = event.target.value.toLowerCase();
    setSearchFacilityName(searchFacilityName);
    filterAndSortFacilities(
      searchFacilityName,
      searchMerchantName,
      filterType,
      sortType
    );
  };

  const handleSearchMerchantName = (event) => {
    const searchMerchantName = event.target.value.toLowerCase();
    setSearchMerchantName(event.target.value);
    filterAndSortFacilities(
      searchFacilityName,
      searchMerchantName,
      filterType,
      sortType
    );
  };

  const handleFilterType = (event) => {
    const type = event.target.value;
    setFilterType(type);
    filterAndSortFacilities(
      searchFacilityName,
      searchMerchantName,
      type,
      sortType
    );
  };

  const handleSortRating = () => {
    const newSortType = sortType === "asc" ? "desc" : "asc";
    setSortType(newSortType);
    filterAndSortFacilities(
      searchFacilityName,
      searchMerchantName,
      filterType,
      newSortType
    );
  };

  const filterAndSortFacilities = (
    searchFacility,
    searchMerchant,
    type,
    sort
  ) => {
    let filtered = facilities;

    filtered = filtered.filter((facility) =>
      facility.facilityName.toLowerCase().includes(searchFacility)
    );

    filtered = filtered.filter((facility) =>
      facility.merchant_name.toLowerCase().includes(searchMerchant)
    );

    if (type !== "") {
      filtered = filtered.filter((facility) => facility.type === type);
    }

    filtered.sort((a, b) => {
      if (sort === "asc") {
        return a.rating - b.rating;
      } else {
        return b.rating - a.rating;
      }
    });

    setFilteredFacilities(filtered);
  };

  const showFacilityDetails = (facility) => {
    setSelectedFacilityDetails(facility);
    setShowModal(true);
    setShownDescription("");
    let tempDes = "";
    if (facility.isCustomDescription) {
      facility.description.forEach((element) => {
        if (element !== "Others") {
          tempDes = tempDes + element + ", ";
        }
      });
      tempDes += facility.customDescription;
    } else {
      facility.description.forEach((element) => {
        tempDes = tempDes + element + ", ";
      });
      tempDes = tempDes.substring(0, tempDes.length - 2);
    }
    setShownDescription(tempDes);
  };

  const handleDelete = async (id, name) => {
    // Show confirmation dialog
    setFacilityNameToDelete(name);
    setFacilityToDelete(id);
    setShowConfirmation(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteDoc(doc(db, "facility", facilityToDelete));
      const updatedFacilities = facilities.filter(
        (facility) => facility.id !== facilityToDelete
      );
      console.log("Delete Facility", facilityToDelete);
      setFacilities(updatedFacilities);
      setShowConfirmation(false); // Close confirmation dialog after delete
    } catch (error) {
      console.error("Error deleting facility: ", error);
    }
  };

  const handleEdit = (facility) => {
    setError("");
    setFacilityToEdit(facility);
    setEditedFacilityName(facility.facilityName);
    setEditedFacilityLocation(facility.location);
    setEditedFacilityType(facility.type);
    setEditedFacilityDescription(facility.description || ""); // Set default description if available
    setEditedCustomDescription(facility.customDescription);
    setIsCustomDescription(facility.isCustomDescription);
    setShowEditModal(true);
  };

  const handleEditConfirmation = async () => {
    if (
      (!editedFacilityName || editedFacilityName.trim() === "") &&
      (!editedFacilityDescription || editedFacilityDescription.length === 0)
    ) {
      return setError(
        "Facility Name and Facility description should not be empty"
      );
    }

    if (!editedFacilityName || editedFacilityName.trim() === "") {
      return setError("Facility Name should not be empty");
    }

    if (!editedFacilityDescription || editedFacilityDescription.length === 0) {
      return setError("Facility description should not be empty");
    }

    if (isCustomDescription && !editedCustomDescription) {
      return setError("Custom description should not be empty");
    }
    try {
    } catch (error) {
      alert("Error in editing the facility, please try again.");
    }
    console.log("Edited Facility Details:", {
      id: facilityToEdit.id,
      editedFacilityName,
      editedFacilityLocation,
      editedFacilityType,
      editedFacilityDescription,
      editedCustomDescription,
      isCustomDescription,
    });
    const facilityRef = doc(db, "facility", facilityToEdit.id);

    // Set the "capital" field of the city 'DC'
    await updateDoc(facilityRef, {
      facilityName: editedFacilityName,
      location: editedFacilityLocation,
      type: editedFacilityType,
      description: editedFacilityDescription,
      customDescription: editedCustomDescription,
      isCustomDescription: isCustomDescription,
    });

    setShowEditModal(false); // Close the edit modal after editing
  };

  const handleCheckboxChange = (option, e) => {
    let updatedDescriptions;
    if (option === "Others") {
      updatedDescriptions = e.target.checked
        ? [...editedFacilityDescription, "Others"]
        : editedFacilityDescription.filter((desc) => desc !== "Others");
      if (!e.target.checked) {
        setEditedCustomDescription("");
        setIsCustomDescription(false);
      } else {
        setIsCustomDescription(true);
      }
    } else {
      updatedDescriptions = e.target.checked
        ? [...editedFacilityDescription, option]
        : editedFacilityDescription.filter((desc) => desc !== option);
    }
    setEditedFacilityDescription(updatedDescriptions);
  };

  const handleViewRating = async () => {
    setShowRatingModal(true);
    const q = query(
      collection(db, "rating"),
      where("facilityID", "==", selectedFacilityDetails.id)
    );
    const querySnapshot = await getDocs(q);
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    console.log("Rating for facility", selectedFacilityDetails, data);
    const mergedDetails = data.map((rating) => {
      const correspondingItem = users.find((user) => user.id === rating.userID);
      return correspondingItem ? { ...rating, ...correspondingItem } : null;
    });
    console.log("Rating merge with user ", mergedDetails);
    const filteredMergedDetails = mergedDetails.filter((item) => item !== null);
    setSelectedFacilityRating(filteredMergedDetails);
  };

  return (
    <div>
      <div className="table-responsive px-5 my-1 mt-3 mt-sm-2 pt-1">
        <div className="row mb-3">
          <div className="col-md-3">
            <input
              type="text"
              placeholder="Search by facility name..."
              value={searchFacilityName}
              onChange={handleSearchFacilityName}
              className="form-control"
            />
          </div>
          <div className="col-md-3 mt-3 mt-md-0">
            <input
              type="text"
              placeholder="Search by merchant name..."
              value={searchMerchantName}
              onChange={handleSearchMerchantName}
              className="form-control"
            />
          </div>
          <div className="col-md-3 mt-3 mt-md-0">
            <select onChange={handleFilterType} className="form-select">
              <option value="">All Types</option>
              <option value="Toilet">Toilet</option>
              <option value="Rest">Rest</option>
              <option value="Other">Other</option>
              {/* Add more options as needed */}
            </select>
          </div>
          <div className="col-md-3 mt-3 mt-md-0">
            <button onClick={handleSortRating} className="btn custom-button">
              Sort by Rating ({sortType === "asc" ? "Ascending" : "Descending"})
            </button>
          </div>
        </div>
        <table className="table mt-3 mt-md-0">
          <thead>
            <tr className="custom-trow">
              <th className="custom-thead">Facility</th>
              <th className="custom-thead">Merchant</th>
              <th className="custom-thead">Type</th>
              <th className="custom-thead">Rating</th>
              <th className="custom-thead">Action</th>
              <th className="custom-thead"></th>
            </tr>
          </thead>
          <tbody>
            {facilitiesToShow.map((facility) => (
              <tr className="custom-trow" key={facility.id}>
                <td data-label="Facility">{facility.facilityName}</td>
                <td data-label="Merchant Name">{facility.merchant.name}</td>
                <td data-label="Type">{facility.type}</td>
                <td data-label="Rating">{facility.rating.toFixed(2)}</td>
                <td data-label="Action">
                  <i
                    className="bi bi-pencil-fill edit-icon mx-2 fs-4"
                    onClick={() => handleEdit(facility)}
                  ></i>
                  <i
                    className="bi bi-trash-fill trash-icon mx-2 fs-4"
                    onClick={() =>
                      handleDelete(facility.id, facility.facilityName)
                    }
                  ></i>
                </td>
                <td>
                  <Button
                    id="button-active"
                    className="custom-button"
                    onClick={() => showFacilityDetails(facility)}
                  >
                    View
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="d-flex justify-content-end align-items-center mt-3">
          <div className="justify-content-center">
            <h6 className="me-3" style={{ color: "grey", fontSize: "15px" }}>
              {currentPage} of {totalPages > 0 ? totalPages : 1} pages
            </h6>
          </div>
          <button
            className="btn custom-button me-2"
            onClick={prevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <button
            className="btn custom-button "
            onClick={nextPage}
            disabled={currentPage === totalPages || totalPages==0}
          >
            Next
          </button>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Facility Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Display selected facility details */}
          {selectedFacilityDetails && (
            <div>
              <p>
                <strong>Name</strong>: {selectedFacilityDetails.facilityName}
              </p>
              <p>
                <strong>Merchant</strong>:{" "}
                {selectedFacilityDetails.merchant.name}
              </p>
              <p>
                <strong>Type</strong>: {selectedFacilityDetails.type}
              </p>
              <p>
                <strong>Location</strong>: {selectedFacilityDetails.location}
              </p>
              <p>
                <strong>Rating</strong>:{" "}
                {selectedFacilityDetails.rating.toFixed(2)}
              </p>
              <p>
                <strong>Description</strong>:{" "}
                {shownDescription && shownDescription}
              </p>
              <Button
                id="button-active"
                className="custom-button"
                onClick={() => handleViewRating()}
              >
                Show Rating History
              </Button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="button-active"
            className="custom-button"
            onClick={() => setShowModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)}>
        <Modal.Header closeButton>
          <i className="bi bi-trash-fill fs-4 me-2"></i>
          <Modal.Title className="fs-4">Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mt-4 d-flex flex-column align-items-center justify-content-center">
          Are you sure to delete facility:{" "}
          <p className="name">{facilityNameToDelete}</p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between mt-4">
          <Button
            id="button-active"
            className="custom-button"
            onClick={confirmDelete}
          >
            Confirm
          </Button>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmation(false)}
            className="cancel-button"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <i className="bi bi-pencil-fill fs-4 me-2"></i>
          <Modal.Title>Edit Facility</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="editedFacilityName">
              <Form.Label>
                Facility Name <span className="req">*</span>
                {inputError && <span className="req-input">{inputError}</span>}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={editedFacilityName}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (inputValue.length <= 50) {
                    setEditedFacilityName(inputValue);
                    setInputError("");
                  } else {
                    setEditedFacilityName(inputValue.slice(0, 50));
                    setInputError("should not longer than 50 character");
                  }
                }}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="editedFacilityLocation">
              <Form.Label>Location</Form.Label>
              <Form.Control
                type="text"
                placeholder="eg: first floor"
                value={editedFacilityLocation}
                onChange={(e) => setEditedFacilityLocation(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="facilityTypes">
              <Form.Label>
                Type <span className="req">*</span>
              </Form.Label>
              <Form.Control
                as="select"
                value={editedFacilityType}
                onChange={(e) => {
                  setEditedFacilityType(e.target.value);
                  setEditedFacilityDescription([]); // Reset description when type changes
                  setEditedCustomDescription("");
                  setIsCustomDescription(false);
                }}
              >
                {facilityTypes.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group
              className="mb-3"
              controlId="editededitedFacilityDescription"
            >
              <Form.Label>
                Description <span className="req">*</span>
              </Form.Label>
              {editedFacilityType === "Toilet" && (
                <div>
                  <Form.Check
                    type="checkbox"
                    label="Male Toilet"
                    checked={editedFacilityDescription.includes("Male Toilet")}
                    onChange={(e) => handleCheckboxChange("Male Toilet", e)}
                  />
                  <Form.Check
                    type="checkbox"
                    label="Female Toilet"
                    checked={editedFacilityDescription.includes(
                      "Female Toilet"
                    )}
                    onChange={(e) => handleCheckboxChange("Female Toilet", e)}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Family Toilet"
                    checked={editedFacilityDescription.includes(
                      "Family Toilet"
                    )}
                    onChange={(e) => handleCheckboxChange("Family Toilet", e)}
                  />

                  <Form.Check
                    type="checkbox"
                    label="OKU Toilet"
                    checked={editedFacilityDescription.includes("OKU Toilet")}
                    onChange={(e) => handleCheckboxChange("OKU Toilet", e)}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Others"
                    checked={editedFacilityDescription.includes("Others")}
                    onChange={(e) => handleCheckboxChange("Others", e)}
                  />
                  {editedFacilityDescription.includes("Others") && (
                    <Form.Control
                      type="text"
                      placeholder="Enter description"
                      value={editedCustomDescription}
                      onChange={(e) =>
                        setEditedCustomDescription(e.target.value)
                      }
                      required
                    />
                  )}
                </div>
              )}

              {editedFacilityType === "Rest" && (
                <div>
                  <Form.Check
                    type="checkbox"
                    label="Seating Area"
                    checked={editedFacilityDescription.includes("Seating Area")}
                    onChange={(e) => handleCheckboxChange("Seating Area", e)}
                  />
                  <Form.Check
                    type="checkbox"
                    label="Restrooms"
                    checked={editedFacilityDescription.includes("Restrooms")}
                    onChange={(e) => handleCheckboxChange("Restrooms", e)}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Pet-Friendly Zone"
                    checked={editedFacilityDescription.includes(
                      "Pet-Friendly Zone"
                    )}
                    onChange={(e) =>
                      handleCheckboxChange("Pet-Friendly Zone", e)
                    }
                  />

                  <Form.Check
                    type="checkbox"
                    label="Tables and Chairs"
                    checked={editedFacilityDescription.includes(
                      "Tables and Chairs"
                    )}
                    onChange={(e) =>
                      handleCheckboxChange("Tables and Chairs", e)
                    }
                  />

                  <Form.Check
                    type="checkbox"
                    label="Others"
                    checked={editedFacilityDescription.includes("Others")}
                    onChange={(e) => handleCheckboxChange("Others", e)}
                  />
                  {editedFacilityDescription.includes("Others") && (
                    <Form.Control
                      type="text"
                      placeholder="Enter description"
                      value={editedCustomDescription}
                      onChange={(e) =>
                        setEditedCustomDescription(e.target.value)
                      }
                      required
                    />
                  )}
                </div>
              )}

              {editedFacilityType === "Other" && (
                <div>
                  <Form.Check
                    type="checkbox"
                    label="Others"
                    checked={editedFacilityDescription.includes("Others")}
                    onChange={(e) => handleCheckboxChange("Others", e)}
                  />
                  {editedFacilityDescription.includes("Others") && (
                    <Form.Control
                      type="text"
                      placeholder="Enter description"
                      value={editedCustomDescription}
                      onChange={(e) =>
                        setEditedCustomDescription(e.target.value)
                      }
                      required
                    />
                  )}
                </div>
              )}
            </Form.Group>
            {error && <Alert variant="danger mt-2">{error}</Alert>}

            <Modal.Footer className="d-flex justify-content-between mt-4">
              <Button
                className="custom-button"
                onClick={handleEditConfirmation}
              >
                Confirm
              </Button>
              <Button
                variant="secondary"
                onClick={() => setShowEditModal(false)}
                className="cancel-button"
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showRatingModal} onHide={() => setShowRatingModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Usage History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Display selected facility details */}
          {selectedFacilityDetails && (
            <div>
              <p>
                <strong>Facility</strong>:{" "}
                {selectedFacilityDetails.facilityName}
              </p>
              <p>
                <strong>Rating</strong>:{" "}
                {selectedFacilityDetails.rating.toFixed(2)}
              </p>
              <p>
                <strong>Number of Rating</strong>:{" "}
                {selectedFacilityRating.length}
              </p>
              <p>
                <strong>Records</strong>
              </p>
              <div className="history-container">
                {selectedFacilityRating.map(
                  (rating, index) =>
                    rating &&
                    rating.name && (
                      <div className="history-item mt-2" key={index}>
                        <div>
                          <span>
                            <span>
                              <i className="bi bi-chat-dots-fill icon"></i>
                            </span>
                            <strong className="fac-name ms-1">
                              {rating.name}
                            </strong>
                          </span>
                          <div className="mt-1">
                            <span className="type-field">
                              Rating: {rating.rating}
                            </span>
                            <span className="ms-5">
                              Time:{" "}
                              {rating.rateDateTime &&
                                new Date(
                                  rating.rateDateTime.seconds * 1000
                                ).toLocaleString()}
                            </span>
                            {/* Replace usage.timestamp with the actual timestamp property */}
                          </div>
                          <div className="mt-1">
                            <span>Comment: </span>
                            <div>
                              <span id="comment-width">{rating.comment}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="button-active"
            className="custom-button"
            onClick={() => setShowRatingModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
